import { Component, Input } from '@angular/core';

@Component({
  selector: 'psc-section-title',
  styleUrls: ['section-title.component.scss'],
  templateUrl: './section-title.component.html',
})
export class SectionTitleComponent {
  @Input() title: string;
  @Input() subtitle: string;

  @Input() size: 'normal' | 'large' | 'small' = 'large';
  @Input() alignment: 'left' | 'center' | 'right' = 'center';
  @Input() color: string = 'text-color-blue1';
  @Input() lineColor: string;

  @Input() lineThickness: number = 4;
  @Input() lineWidthPercentage: number = 50;

}
